
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 10">
  <path
    d="M0.926589 0H12.0457C12.5574 0 12.9723 0.408597 12.9723 0.912626V8.82205C12.9723 9.32608 12.5574 9.73468 12.0457 9.73468H0.926589C0.414848 9.73468 0 9.32608 0 8.82205V0.912626C0 0.408597 0.414848 0 0.926589 0ZM6.30091 4.89434L6.30076 4.89444H6.30107L6.30091 4.89434ZM11.919 1.3717L6.30091 4.89434L0.682847 1.3717L0.0194092 2.39841L5.80318 6.02488C6.10683 6.21534 6.495 6.21534 6.79865 6.02488L12.5824 2.39841L11.919 1.3717Z"
  />
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Email',
    }) as DefineComponent
    </script>
    